import { render } from "./sponsors.vue?vue&type=template&id=f77e1a3a&scoped=true"
import script from "./sponsors.vue?vue&type=script&lang=js"
export * from "./sponsors.vue?vue&type=script&lang=js"

import "./sponsors.vue?vue&type=style&index=0&id=f77e1a3a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f77e1a3a"

export default script